import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from "react";
import InputBase from "@mui/material/InputBase";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton, useTheme } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const SearchBar = ({
  requestSearch = () => {},
  style,
  placeholder,
  handleSubmit = () => {},
  disable = false,
  color,
  flex = "initial",
  showSubmitBtn = false,
  seachIconFontSize = "24px",
}) => {
  const [searchText, setSearchText] = useState("");
  const theme = useTheme();

  const handleSearch = (val) => {
    setSearchText(val);
    requestSearch(val);
  };

  return (
    <div
      className={showSubmitBtn ? "searchInAssist2" : "searchInAssist1"}
      style={{ display: "flex", flex: flex, gap: theme.size[4] }}
    >
      <InputBase
        sx={{
          flex: 1,
          fontSize: "14px",
          background: "none !important",
          color: theme.palette.primary.searchIcon,
          borderBottom: `1px solid ${theme.palette.border.main}`,
          marginTop: "5px",
        }}
        disabled={disable}
        placeholder={placeholder}
        value={searchText}
        onChange={(e) => handleSearch(e.target.value)}
        style={style}
        fullWidth
        onKeyDown={(e) => {
          if (e.code === "Enter") {
            handleSubmit(searchText);
            setSearchText("");
          }
        }}
        startAdornment={
          <InputAdornment sx={{ color: { color } }} position="start">
            <SearchIcon
              sx={{
                color: theme.palette.primary.searchIcon,
                fontSize: seachIconFontSize,
              }}
            />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment
            sx={{ color: { color }, cursor: "pointer", gap: theme.size[16] }}
            position="start"
          >
            {searchText && (
              <ClearIcon
                sx={{ color: theme.palette.primary.searchIcon }}
                onClick={() => handleSearch("")}
                fontSize="small"
              />
            )}
            {/* {showSubmitBtn && (
              <IconButton
                display="flex"
                padding={1}
                disableRipple
                sx={{
                  backgroundColor: theme.palette.button.background,
                  border: `${theme.size[1]} solid ${theme.palette.button.background}`,
                  color: theme.palette.button.text,
                  borderRadius: theme.size[5],
                  "&:hover": {
                    backgroundColor: theme.palette.button.background,
                    color: theme.palette.button.text,
                  },
                  "&:disabled": {
                    opacity: "0.5",
                    backgroundColor: theme.palette.grey[300],
                    color: theme.palette.grey[900],
                    border: `${theme.size[1]} solid ${theme.palette.grey[300]}`,
                  },
                }}
                onClick={() => {
                  handleSubmit(searchText);
                  setSearchText("");
                }}
                disabled={searchText === ""}
              >
                <SendIcon />
              </IconButton>
            )} */}
          </InputAdornment>
        }
      />
    </div>
  );
};

export default SearchBar;
